import { createContext, useContext } from 'react'

export interface ChatScrollValue {
  handleScroll: () => void
  isAtBottom: boolean
  hasContentOutOfView: boolean
  enableFollowAndScrollToBottom: () => void
  dynamicSpacerHeight: number
  messagesWrapperRef: React.RefObject<HTMLDivElement | null>
}

export const ChatScrollContext = createContext<ChatScrollValue | null>(null)

export function useChatScrollContext(): ChatScrollValue {
  const ctx = useContext(ChatScrollContext)
  if (!ctx) throw new Error('useChatScrollContext must be used within TripPlannerChatProvider')
  return ctx
}
